<div class="flag" [ngClass]="size" *ngIf="backgroundUrl">
  <div class="img" [style.background-image]="backgroundUrl"></div>
</div>
